module.exports = __webpack_public_path__ + "fonts/Roboto-Light.10ad0f8.woff";